import React from 'react';
import Link from 'next/link';
import {
    ProgramInfoTitle,
    ProgramInfoTitleLink,
    ProgramInfoEpisodeLink,
    ProgramInfoDivider,
} from './ProgramInfo.styles';
import TopBarVariants from './TopBarVariants';

const ProgramInfo = ({
    title,
    episodeTitle,
    url,
    videos,
    selectedVideoId,
    updateAccessibilityVersion,
    parentUrl,
}) => {
    if (!title || !episodeTitle) {
        return null;
    }

    const variants = videos?.filter((video) => video.svtId && video.svtId !== selectedVideoId);

    return (
        <>
            <ProgramInfoTitle data-rt="program-info-title">
                <Link
                    href={{
                        pathname: parentUrl,
                    }}
                    passHref
                >
                    <ProgramInfoTitleLink>{title}</ProgramInfoTitleLink>
                </Link>

                {title !== episodeTitle && (
                    <>
                        <ProgramInfoDivider />
                        <Link
                            href={{
                                pathname: url,
                            }}
                            passHref
                        >
                            <ProgramInfoEpisodeLink data-rt="episode-link">
                                {episodeTitle}
                            </ProgramInfoEpisodeLink>
                        </Link>
                    </>
                )}
            </ProgramInfoTitle>
            <TopBarVariants variants={variants} onClick={updateAccessibilityVersion} />
        </>
    );
};

export default ProgramInfo;
